import './ccf-pin-control-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfPinControlIconProps extends SvgIconProps {
  fillColor?: string;
}

/**
 * Component diaplays pin control icon
 * @param props -CcfPinControlIconProps
 * @returns pin control svg icon
 * @example <CcfPinControlIcon/>
 */
export function CcfPinControlIcon(props: CcfPinControlIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Pin">
        <path
          id="pin-2"
          data-name="pin"
          d="M13.81,4.2,9.82.21A.756.756,0,0,0,9.331,0a.635.635,0,0,0-.49.21,3.733,3.733,0,0,0-.98,2.8L6.6,4.339a5.02,5.02,0,0,0-2.03-.42A5.344,5.344,0,0,0,.723,5.529l-.07.14a.5.5,0,0,0-.21.42.756.756,0,0,0,.21.49L3.312,9.308.373,13.017s-.49.56-.28.91c0,0,.35.28.84-.14l3.779-3.009,2.659,2.659a.635.635,0,0,0,.49.21.756.756,0,0,0,.49-.21l.07-.07a5.546,5.546,0,0,0,1.26-5.879l1.33-1.33h.35a3.624,3.624,0,0,0,2.449-.98.635.635,0,0,0,.21-.49.756.756,0,0,0-.21-.49Zm-2.449.56h-.21l-.63-.07L8.071,7.138l.35.84a4.314,4.314,0,0,1-.49,3.919l-2.1-2.17-1.4-1.47-2.1-2.17a4.19,4.19,0,0,1,2.379-.77,12.358,12.358,0,0,1,1.4.28l.84.35L9.4,3.5l-.07-.7a1.835,1.835,0,0,1,.14-1.05L12.2,4.479a1.345,1.345,0,0,1-.84.28Z"
          transform="translate(5.959 5.031)"
          fill={props.fillColor ? props.fillColor : '#526b7a'}
        />
      </g>
    </SvgIcon>
  );
}

export default CcfPinControlIcon;
